import * as z from 'zod/mini'
import { cancellationDeadlineField } from '../utils/cancellation-deadline'

/**
 * Field rules for a reservation, shared by the HTTP body, the form and the domain operation.
 * The time range is not here: it is an ISO string on the wire and a `Date` in the domain, so each
 * layer declares its own pair and applies `endAfterStart` to it.
 */
export const reservationFields = {
  name: z.string().check(z.trim(), z.minLength(2), z.maxLength(40)),
  cancellationDeadline: cancellationDeadlineField,
}

/**
 * The texts on a reservation, each with its own audience:
 *
 * - `description` is the customer's: copied from the service on a public booking, written by hand on a manual one,
 *   shown on the reservation's public page and in its e-mails. HTML from the editor, sanitised by the API on write.
 * - `note` is the premise's own (pilot): plain text the customer never sees.
 * - `cancellationReason` is written for the customer when the premise cancels, and goes into the cancel e-mail.
 *   Plain text, HTML-escaped before it reaches a template.
 */
export const reservationTextFields = {
  description: z.string().check(z.maxLength(5000)),
  note: z.string().check(z.trim(), z.maxLength(2000)),
  cancellationReason: z.string().check(z.trim(), z.maxLength(500)),
}
